import { combineReducers } from "redux";
import CommonReducer from "./common/reducer";
import AuthReducer from "./auth/reducer";
import ThemeReducer from "./theme/reducer";
import CartReducer from "./cart/reducer";
import VariantReducer from "./variant/reducer";
import AddonsReducer from "./addons/reducer";
import DiscoverReducer from "./discover/reducer";
import DiscoverFiltersReducer from "./discover/filters-reducer";

import Dashboard from "../entrypoints/dashboard/screens/dashboard/reducer";
import Order from "../entrypoints/dashboard/screens/invoices/invoices/reducer";

import Products from "../entrypoints/dashboard/screens/products/product/reducer";
import Groups from "../entrypoints/dashboard/screens/products/group/reducer";

import Categories from "../entrypoints/dashboard/screens/products/categories/reducer";
import BlackList from "../entrypoints/dashboard/screens/fraud/blacklist/reducer";
import Whitelist from "../entrypoints/dashboard/screens/fraud/whitelist/reducer";
import Webhooks from "../entrypoints/dashboard/screens/developer/webhooks/reducer";
import WebhookLogs from "../entrypoints/dashboard/screens/developer/webhook-logs/reducer";
import Tickets from "../entrypoints/dashboard/screens/comms/tickets/reducer";
import Coupons from "../entrypoints/dashboard/screens/products/coupons/reducer";
import Feedbacks from "../entrypoints/dashboard/screens/comms/feedback/reducer";
import Reports from "../entrypoints/dashboard/screens/analytics/reports/reducer";
import Nav from "../entrypoints/dashboard/layouts/dashboard/reducer";
import ReportsSystem from "../entrypoints/admin/screens/reportSystem/reducer";

import Users from '../entrypoints/admin/screens/users/reducer'
import Shops from '../entrypoints/admin/screens/shops/reducer'
import top from '../entrypoints/admin/screens/top/reducer'


const reducer = combineReducers({
  discover: DiscoverReducer,
  discoverFilters: DiscoverFiltersReducer,
  cart: CartReducer,
  variant: VariantReducer,
  addons: AddonsReducer,
  users: Users,
  shops: Shops,
  top: top,
  common: CommonReducer,
  theme: ThemeReducer,
  tickets: Tickets,
  auth: AuthReducer,
  blacklist: BlackList,
  whitelist: Whitelist,
  webhooks: Webhooks,
  webhookLogs: WebhookLogs,
  coupons: Coupons,
  dashboard: Dashboard,
  products: Products,
  groups: Groups,
  category: Categories,
  feedbacks: Feedbacks,
  report: Reports,
  order: Order,
  nav: Nav,
  reports: ReportsSystem,
})

export default reducer